import redirectSource from './AvatarRedirect';
export default redirectSource('vkontakte', 'vkontakteId');